import _ from 'lodash'

export function parseMinMax(min, max) {
  if (
    Number.isInteger(parseInt(min, 10))
    && Number.isInteger(parseInt(max, 10))
    && parseInt(min, 10) <= parseInt(max, 10)
  ) {
    return { min: parseInt(min, 10), max: parseInt(max, 10) }
  }
  return null
}

export function split(params) {
  return _.split(decodeURIComponent(params), '|')
}
